import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardContent,
  Grid,
  Box,
  Typography,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Autocomplete,
} from "@mui/material";
import { getClientList, getSavedAnalytics } from "src/api/analytics";
import { getDevices } from "src/api/devices";
import { color } from "framer-motion";


const manageAnalyticsSettings = (response) => {
  let results = {}
  if(response){
  response.forEach((row) => {
    if (!(row.CameraId in results))
      results[row.CameraId] = { mainIds: [], subIds: [] }
    results[row.CameraId].mainIds.push(row.analyticsmainid)
    results[row.CameraId].subIds.push(row.analyticssubid)
  })}
  return results
}

const organizeAnalyticsData = (response) => {
  const categories = {};
  const analyticsMap = {};
  
  if (response) {
    response.forEach((row) => {
      const mainId = row.analyticsmainid;
      const mainName = row.AnalyticName;
      const subId = row.analyticssubid;
      const subName = row.analyticssubname;
      
      if (!categories[mainId]) {
        categories[mainId] = {
          id: mainId,
          name: mainName,
          subAnalytics: []
        };
      }
      
      if (!categories[mainId].subAnalytics.find(sub => sub.id === subId)) {
        categories[mainId].subAnalytics.push({
          id: subId,
          name: subName
        });
      }
      
      if (!analyticsMap[mainId]) {
        analyticsMap[mainId] = [];
      }
      if (!analyticsMap[mainId].find(sub => sub.id === subId)) {
        analyticsMap[mainId].push({
          id: subId,
          name: subName
        });
      }
    });
  }
  
  return { categories: Object.values(categories), analyticsMap };
};


const AssignAnalytics = () => {
  const [clientType, setClientType] = useState("");
  const [clientInfo, setClientInfo] = useState([]);
  const [setTypeClient, setSelectedTypeClient] = useState([]);
  const [client, setClient] = useState("");
  const [clientCameras, setClientCameras] = useState([]);
  const [devices, setDevices] = useState([]);
  const [selectedCamera, setSelectedCamera] = useState(null);
  const [analyticsSettings, setAnalyticsSettings] = useState({})
  const [analyticsData, setAnalyticsData] = useState({ categories: [], analyticsMap: {} });
  const [availableSubAnalytics, setAvailableSubAnalytics] = useState([]);

  // Drawing states
  const [mode, setMode] = useState(null); // "line" | "ignore" | "monitor" | "object" | "erase" | "edit"
  const [startPoint, setStartPoint] = useState(null);
  const [mousePos, setMousePos] = useState(null);
  const [currentPolygon, setCurrentPolygon] = useState([]);
  const [deviceData, setDeviceData] = useState({});
  const [draggingPoint, setDraggingPoint] = useState(null);
  const [analyticsCategory, setAnalyticsCategory] = useState("");
  const [selectedAnalytics, setSelectedAnalytics] = useState("");

  const canvasRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    getClientList((response) => {
      if (response.status === 200) setClientInfo(response.data || []);
    });
    let _body = { status: "1", limit: 0 };
    getDevices(_body, (response) => {
      if (response.status === 200) setDevices(response.data || []);
    });
  }, []);


  useEffect(() => {
    if (!clientType) {
      setSelectedTypeClient([]);
      return;
    }
    const filtered = clientInfo.filter((row) => row.ClientType === clientType);
    setSelectedTypeClient(filtered);
  }, [clientType, clientInfo]);

 
  useEffect(() => {
    if (!selectedCamera) return;

    const id = selectedCamera.deviceid;
    setDeviceData((prev) => {
      if (prev[id]) return prev;
      return {
        ...prev,
        [id]: {
          lines: [],
          ignoreAreas: [],
          monitorAreas: [],
          objectSizes: [],
        },
      };
    });


    const img = imageRef.current;
    const canvas = canvasRef.current;
    if (img && canvas) {
     
      if (img.complete && img.clientWidth && img.clientHeight) {
        canvas.width = img.clientWidth;
        canvas.height = img.clientHeight;
      } else {
       
      }
    }
    
  }, [selectedCamera]);



  
  const drawAll = () => {
    const canvas = canvasRef.current;
    const img = imageRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (!selectedCamera) return;

    const id = selectedCamera.deviceid;
    const data = deviceData[id] || {
      lines: [],
      ignoreAreas: [],
      monitorAreas: [],
      objectSizes: [],
    };

    const drawDot = (x, y, color = "#000") => {
      ctx.beginPath();
      ctx.arc(x, y, 5, 0, Math.PI * 2);
      ctx.fillStyle = color;
      ctx.fill();
      ctx.closePath();
    };

    // Draw lines
    data.lines.forEach((line) => {
      ctx.beginPath();
      ctx.moveTo(line.start.x, line.start.y);
      ctx.lineTo(line.end.x, line.end.y);
      ctx.strokeStyle = line.color || "#02010f";
      ctx.lineWidth = 3;
      ctx.stroke();
      ctx.closePath();
      if (mode === "edit") {
        drawDot(line.start.x, line.start.y, "#02010f");
        drawDot(line.end.x, line.end.y, "#02010f");
      }
    });

    // Draw object size lines
    data.objectSizes.forEach((line) => {
      ctx.beginPath();
      ctx.moveTo(line.start.x, line.start.y);
      ctx.lineTo(line.end.x, line.end.y);
      ctx.strokeStyle = line.color || "#10B981";
      ctx.lineWidth = 2;
      ctx.stroke();
      ctx.closePath();
      drawDot(line.start.x, line.start.y, "#10B981");
      drawDot(line.end.x, line.end.y, "#10B981");
      if (mode === "edit") {
        
      }
    });

    // Ignore areas (polygons)
    data.ignoreAreas.forEach((poly) => {
      if (!poly.length) return;
      ctx.beginPath();
      ctx.moveTo(poly[0].x, poly[0].y);
      poly.forEach((p) => ctx.lineTo(p.x, p.y));
      ctx.closePath();
      ctx.strokeStyle = "#EF4444";
      ctx.lineWidth = 2;
      ctx.stroke();
      ctx.globalAlpha = 0.12;
      ctx.fillStyle = "#EF4444";
      ctx.fill();
      ctx.globalAlpha = 1;
      if (mode === "edit") poly.forEach((p) => drawDot(p.x, p.y, "#EF4444"));
    });

    // Monitor areas
    data.monitorAreas.forEach((poly) => {
      if (!poly.length) return;
      ctx.beginPath();
      ctx.moveTo(poly[0].x, poly[0].y);
      poly.forEach((p) => ctx.lineTo(p.x, p.y));
      ctx.closePath();
      ctx.strokeStyle = "#3B82F6";
      ctx.lineWidth = 2;
      ctx.stroke();
      ctx.globalAlpha = 0.12;
      ctx.fillStyle = "#3B82F6";
      ctx.fill();
      ctx.globalAlpha = 1;
      if (mode === "edit") poly.forEach((p) => drawDot(p.x, p.y, "#3B82F6"));
    });

    // Temporary preview (line/object)
    if (startPoint && mousePos && (mode === "line" || mode === "object")) {
      ctx.beginPath();
      ctx.moveTo(startPoint.x, startPoint.y);
      ctx.lineTo(mousePos.x, mousePos.y);
      ctx.strokeStyle = "rgba(1, 1, 15, 0.95)";
      ctx.setLineDash([6, 4]);
      ctx.lineWidth = 2;
      ctx.stroke();
      ctx.setLineDash([]);
      ctx.closePath();
    }

    // Temporary polygon preview
    if (currentPolygon.length && (mode === "ignore" || mode === "monitor")) {
      ctx.beginPath();
      ctx.moveTo(currentPolygon[0].x, currentPolygon[0].y);
      currentPolygon.forEach((p) => ctx.lineTo(p.x, p.y));
      if (mousePos) ctx.lineTo(mousePos.x, mousePos.y);
      ctx.strokeStyle = mode === "ignore" ? "#EF4444" : "#3B82F6";
      ctx.lineWidth = 2;
      ctx.setLineDash([6, 4]);
      ctx.stroke();
      ctx.setLineDash([]);
      ctx.closePath();
      currentPolygon.forEach((p) =>
        drawDot(p.x, p.y, mode === "ignore" ? "#EF4444" : "#3B82F6")
      );
    }
  };

 
  const getRelativePos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    return { x: e.clientX - rect.left, y: e.clientY - rect.top };
  };

 
  const handleCanvasClick = (e) => {
    if (!selectedCamera) return;
    const pos = getRelativePos(e);
    const id = selectedCamera.deviceid;

    if (mode === "edit") {
      return;
    }

    
    setDeviceData((prev) => {
      if (prev[id]) return prev;
      return {
        ...prev,
        [id]: {
          lines: [],
          ignoreAreas: [],
          monitorAreas: [],
          objectSizes: [],
        },
      };
    });

   
    if (mode === "line" || mode === "object") {
      if (!startPoint) {
        setStartPoint(pos);
      } else {
        const newLine = { start: startPoint, end: pos };
        const key = mode === "line" ? "lines" : "objectSizes";
        setDeviceData((prev) => {
          const copy = { ...(prev || {}) };
          copy[id] = copy[id] || {
            lines: [],
            ignoreAreas: [],
            monitorAreas: [],
            objectSizes: [],
          };
          copy[id][key] = [...(copy[id][key] || []), newLine];
          return copy;
        });
        setStartPoint(null);
      }
      return;
    }

   
    if (mode === "ignore" || mode === "monitor") {
      const poly = [...currentPolygon, pos];

      if (poly.length > 2) {
        const distToFirst = Math.hypot(poly[0].x - pos.x, poly[0].y - pos.y);
        if (distToFirst < 10) {
        
          const key = mode === "ignore" ? "ignoreAreas" : "monitorAreas";
          setDeviceData((prev) => {
            const copy = { ...(prev || {}) };
            copy[id] = copy[id] || {
              lines: [],
              ignoreAreas: [],
              monitorAreas: [],
              objectSizes: [],
            };
            copy[id][key] = [...(copy[id][key] || []), poly];
            return copy;
          });
          setCurrentPolygon([]);
          return;
        }
      }

      setCurrentPolygon(poly);
      return;
    }

    
    if (mode === "erase") {
      setDeviceData((prev) => {
        const copy = { ...(prev || {}) };
        const dd = copy[id] || {
          lines: [],
          ignoreAreas: [],
          monitorAreas: [],
          objectSizes: [],
        };

        const isPointNearLine = (p1, p2, point, threshold = 8) => {
          const A = point.x - p1.x;
          const B = point.y - p1.y;
          const C = p2.x - p1.x;
          const D = p2.y - p1.y;
          const dot = A * C + B * D;
          const len_sq = C * C + D * D;
          let param = -1;
          if (len_sq !== 0) param = dot / len_sq;
          let xx, yy;
          if (param < 0) {
            xx = p1.x;
            yy = p1.y;
          } else if (param > 1) {
            xx = p2.x;
            yy = p2.y;
          } else {
            xx = p1.x + param * C;
            yy = p1.y + param * D;
          }
          const dx = point.x - xx;
          const dy = point.y - yy;
          return Math.sqrt(dx * dx + dy * dy) < threshold;
        };

        const isPointInPolygon = (poly, point) => {
          let inside = false;
          for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
            const xi = poly[i].x,
              yi = poly[i].y;
            const xj = poly[j].x,
              yj = poly[j].y;
            const intersect =
              yi > point.y !== yj > point.y &&
              point.x < ((xj - xi) * (point.y - yi)) / (yj - yi) + xi;
            if (intersect) inside = !inside;
          }
          return inside;
        };

        dd.lines = (dd.lines || []).filter(
          (l) => !isPointNearLine(l.start, l.end, pos)
        );
        dd.objectSizes = (dd.objectSizes || []).filter(
          (l) => !isPointNearLine(l.start, l.end, pos)
        );
        dd.ignoreAreas = (dd.ignoreAreas || []).filter(
          (poly) => !isPointInPolygon(poly, pos)
        );
        dd.monitorAreas = (dd.monitorAreas || []).filter(
          (poly) => !isPointInPolygon(poly, pos)
        );

        copy[id] = dd;
        return copy;
      });
      return;
    }
  };

  
  const handleMouseMove = (e) => {
    if (!selectedCamera) return;
    const pos = getRelativePos(e);

   
    if (mode === "edit" && draggingPoint) {
      const { type, shapeIndex, pointIndex } = draggingPoint;
      const id = selectedCamera.deviceid;
      setDeviceData((prev) => {
        const copy = JSON.parse(JSON.stringify(prev || {}));
        copy[id] = copy[id] || {
          lines: [],
          ignoreAreas: [],
          monitorAreas: [],
          objectSizes: [],
        };

        const list = copy[id][type];
        if (!list) return prev;
        
        if (Array.isArray(list[shapeIndex]) && list[shapeIndex][pointIndex]) {
          list[shapeIndex][pointIndex] = pos;
        } else if (list[shapeIndex]) {
          if (pointIndex === 0) list[shapeIndex].start = pos;
          else list[shapeIndex].end = pos;
        }
        return copy;
      });
      return;
    }

    setMousePos(pos);
  };


  const handleMouseDown = (e) => {
    if (!selectedCamera || mode !== "edit") return;
    const pos = getRelativePos(e);
    const id = selectedCamera.deviceid;
    const dd = deviceData[id];
    if (!dd) return;

    const near = (p1, p2, t = 8) => Math.hypot(p1.x - p2.x, p1.y - p2.y) < t;

    
    for (const type of ["lines", "objectSizes"]) {
      const list = dd[type] || [];
      for (let i = 0; i < list.length; i++) {
        const l = list[i];
        if (near(pos, l.start)) {
          setDraggingPoint({ type, shapeIndex: i, pointIndex: 0 });
          return;
        }
        if (near(pos, l.end)) {
          setDraggingPoint({ type, shapeIndex: i, pointIndex: 1 });
          return;
        }
      }
    }

   
    for (const type of ["ignoreAreas", "monitorAreas"]) {
      const list = dd[type] || [];
      for (let i = 0; i < list.length; i++) {
        const poly = list[i];
        for (let j = 0; j < poly.length; j++) {
          if (near(pos, poly[j])) {
            setDraggingPoint({ type, shapeIndex: i, pointIndex: j });
            return;
          }
        }
      }
    }
  };

  const handleMouseUp = () => {
    setDraggingPoint(null);
  };

  
  useEffect(() => {
    drawAll();
  }, [deviceData, startPoint, mousePos, currentPolygon, mode, selectedCamera]);

  const onImageLoad = (e) => {
    const canvas = canvasRef.current;
    const img = imageRef.current;
    if (!canvas || !img) return;
    canvas.width = img.clientWidth;
    canvas.height = img.clientHeight;
    drawAll();
  };

  // const onClientChange = (event, value) => {
  //   if (!value) {
  //     setClient("");
  //     setClientCameras([]);
  //     return;
  //   }
  //   const id = value.ID;
  //   setClient(id);
  //   const clientCams = devices.filter((item) => item.clientid === id);
  //   setClientCameras(clientCams);

  //   if(id){
  //     getSavedAnalytics(id, (response) => {
  //       if (response.status === 200) {
  //         const managedData = manageAnalyticsSettings(response.data);
  //         setAnalyticsSettings({ ...managedData });
  //       }
  //     });
  //   }
  // };
const onClientChange = (event, value) => {
  if (!value) {
    setClient("");
    setClientCameras([]);
    setAnalyticsData({ categories: [], analyticsMap: {} });
    setAnalyticsCategory("");
    setSelectedAnalytics("");
    return;
  }
  const id = value.ID;
  setClient(id);
  const clientCams = devices.filter((item) => item.clientid === id);
  setClientCameras(clientCams);

  if(id){
    getSavedAnalytics(id, (response) => {
      if (response.status === 200) {
        const managedData = manageAnalyticsSettings(response.data);
        setAnalyticsSettings({ ...managedData });
        
        // Organize data for dropdowns
        const organizedData = organizeAnalyticsData(response.data);
        setAnalyticsData(organizedData);
      }
    });
  }
};

const handleCategoryChange = (e) => {
  const categoryId = e.target.value;
  setAnalyticsCategory(categoryId);
  setSelectedAnalytics(""); // Reset analytics when category changes
  
  // Update available sub-analytics based on selected category
  if (categoryId && analyticsData.analyticsMap[categoryId]) {
    setAvailableSubAnalytics(analyticsData.analyticsMap[categoryId]);
  } else {
    setAvailableSubAnalytics([]);
  }
}

  const handleCameraChange = (event, value) => {
    setSelectedCamera(value);
    setMode(null);
    setStartPoint(null);
    setMousePos(null);
    setCurrentPolygon([]);
    setDraggingPoint(null);
  };

  return (
    <>
      <Card sx={{ width: "95%", p: 2, margin: "auto", mb: 2 }}>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item md={2}>
              <FormControl fullWidth>
                <InputLabel>Client Type</InputLabel>
                <Select
                  value={clientType}
                  label="Client Type"
                  onChange={(e) => setClientType(e.target.value)}
                >
                  <MenuItem value="US">US</MenuItem>
                  <MenuItem value="INDIA">INDIA</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={2}>
              <Autocomplete
                fullWidth
                options={setTypeClient}
                getOptionLabel={(option) => option.displayname || ""}
                onChange={onClientChange}
                renderInput={(params) => (
                  <TextField {...params} label="Clients" placeholder="Enter Client Name" />
                )}
              />
            </Grid>

            <Grid item xs={2} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Autocomplete
                fullWidth
                id="camera"
                options={clientCameras}
                value={selectedCamera}
                getOptionLabel={(option) => option.devicename || ""}
                onChange={handleCameraChange}
                renderInput={(params) => <TextField {...params} label="Camera" />}
              />
            </Grid>
            <Grid item xs={2}>
             <FormControl fullWidth>
  <InputLabel>Analytics Category</InputLabel>
  <Select
    value={analyticsCategory}
    label="Analytics Category"
    onChange={handleCategoryChange}
  >
    {analyticsData.categories.map((category) => (
      <MenuItem key={category.id} value={category.id}>
        {category.name}
      </MenuItem>
    ))}
  </Select>
</FormControl>
            </Grid>
            <Grid item xs={2}>
             <FormControl fullWidth>
  <InputLabel>Analytics</InputLabel>
  <Select
    value={selectedAnalytics}
    label="Analytics"
    onChange={(e) => setSelectedAnalytics(e.target.value)}
    disabled={!analyticsCategory}
  >
    {availableSubAnalytics.map((analytic) => (
      <MenuItem key={analytic.id} value={analytic.id}>
        {analytic.name}
      </MenuItem>
    ))}
  </Select>
</FormControl>
            </Grid>
            <Grid item xs={2} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Button
                  variant="contained"
                  onClick={() => {
                    console.log("Saved Shapes:", deviceData);
                    setMode(null);
                  }}
                >
                  Save Settings
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {selectedCamera && (
        <Card sx={{ width: "95%", p: 2, margin: "auto" }}>
          <CardContent>
            <Typography variant="subtitle1" gutterBottom>
              Preview - {selectedCamera.devicename}
            </Typography>

            <Box display="flex" gap={2}>
              <Box sx={{ flex: "0 0 65%", position: "relative" }}>
                <img
                  ref={imageRef}
                  src={selectedCamera.snapshot}
                  alt="Preview"
                  style={{ width: "100%", borderRadius: 8, objectFit: "contain", display: "block" }}
                  onLoad={onImageLoad}
                />

                <canvas
                  ref={canvasRef}
                  onClick={handleCanvasClick}
                  onMouseMove={handleMouseMove}
                  onMouseDown={handleMouseDown}
                  onMouseUp={handleMouseUp}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    cursor: mode === "edit" ? "move" : "crosshair",
                    zIndex: 10,
                  }}
                />
              </Box>

             <Box
              sx={{
                flex: "0 0 35%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
              }}
            >
            {[
              { label: "Line", key: "line" },
              { label: "Ignore Area", key: "ignore" },
              { label: "Monitoring Area", key: "monitor" },
              { label: "Object Size", key: "object" },
              { label: "Erase", key: "erase" },
              { label: "Edit Mode", key: "edit" }, 
            ].map((btn) => (
              <Button
                key={btn.key}
                variant="contained"
                sx={{
                  width: 250,
                  backgroundColor:
                    mode === btn.key ? "primary.main" : "rgba(25, 118, 210, 0.2)",
                  color: mode === btn.key ? "#fff" : "primary.main",
                  "&:hover": {
                    backgroundColor:
                      mode === btn.key ? "primary.dark" : "rgba(25, 118, 210, 0.3)",
                  },
                  transition: "background-color 0.2s ease",
                }}
                onClick={() =>
                  btn.key === "edit" ? setMode((m) => (m === "edit" ? null : "edit")) : setMode(btn.key)
                }
              >
                {btn.key === "edit" && mode === "edit" ? "Exit Edit Mode" : btn.label}
              </Button>
            ))}
        </Box>

            </Box>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default AssignAnalytics;




